import { render, staticRenderFns } from "./channelResolutionTime.vue?vue&type=template&id=c39b7642&scoped=true&"
import script from "./channelResolutionTime.vue?vue&type=script&lang=js&"
export * from "./channelResolutionTime.vue?vue&type=script&lang=js&"
import style0 from "./channelResolutionTime.vue?vue&type=style&index=0&id=c39b7642&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c39b7642",
  null
  
)

export default component.exports